/**
 * 44px tile + eyebrow + value.
 *
 * Lifted from the publish drawer's "what will happen" pattern and reused for
 * "what happened": the last deployment, the deploy summary, the empty-state
 * walkthrough on /apps.
 */
const TileRow = ({ tile, eyebrow, value, trailing, isFirst = false }: {
  /** Icon, or a two-digit step number. */
  tile: React.ReactNode,
  eyebrow: React.ReactNode,
  value: React.ReactNode,
  trailing?: React.ReactNode,
  isFirst?: boolean,
}) => (
  <div className={`flex items-center gap-3.5 px-4 py-4 ${isFirst ? '' : 'border-t border-navy-500'}`}>
    <div className="w-11 h-11 flex-none rounded-surface bg-navy-600 border border-navy-500 flex items-center justify-center text-navy-200 font-courrier text-ds-125">
      {tile}
    </div>
    <div className="flex-1 min-w-0 flex flex-col gap-[3px]">
      <span className="b4-eyebrow-tight">{eyebrow}</span>
      <span className="text-ds-135 leading-[1.4] text-white truncate">{value}</span>
    </div>
    {trailing}
  </div>
)

export default TileRow
